export enum InvoiceItemType {
  Invoice,
  CreditNote
}
export enum HeadOfficeInvoiceWorkFlowStatus {
  NotSent,
  Pending,
  Complete
}
export enum RequestType {
  None,
  CreditNote,
  InvoiceNo
}

export enum CreditNoteStatus {
  None,
  Pending,
  Accepted,
  Rejected
}
